<script setup lang="ts">
import {
  CdrLink,
} from '@rei/cedar';
import { replaceCharsFunction } from '../../common/utils';

const { data } = defineProps<{
  data?: any[]
}>();

const getHref = ({ name, id }) => `/help?a=${replaceCharsFunction((name) || '')}---id--${id}`;
const handleClick = () => {};
</script>
<template>
  <div class="help-centers__articles">
    <div v-if="data.length">
      <ul>
        <CdrLink
          v-for="(article, index) in data"
          class="help-center-right-nav-div-link"
          :key="article?.name+index"
          :href="getHref(article)"
          @click="handleClick(article)"
        >
          <li>
            {{ article?.name }}
          </li>
        </CdrLink>
      </ul>
    </div>
    <div
      v-else
      style="padding-left: 1rem;"
    >
      <p>Click on any topic to display the related articles.</p>
    </div>
  </div>
</template>
<style lang="scss">
@import 'src/main/style/helpCenter.scss';
</style>
